<div class="file-storage-demo">
  <h2>File Storage Demo</h2>

  <section class="upload-section">
    <h3>1. Selecciona un fichero</h3>
    <input type="file" (change)="onFileSelected($event)" #fileInput>
    <p *ngIf="selectedFile" class="file-name">{{ selectedFile.name }} ({{ selectedFile.size | number }} bytes)</p>
  </section>

  <section class="action-section">
    <button mat-raised-button color="primary"
      [disabled]="!selectedFile || uploadState === 'uploading'"
      (click)="upload()">
      <mat-icon>cloud_upload</mat-icon>
      {{ uploadState === 'uploading' ? 'Subiendo...' : 'Subir fichero' }}
    </button>

    <mat-progress-bar *ngIf="uploadState === 'uploading'" mode="indeterminate"></mat-progress-bar>
  </section>

  <section *ngIf="uploadState === 'done'" class="result-section">
    <p class="success-text">
      <mat-icon>check_circle</mat-icon>
      Fichero subido: <strong>{{ uploadedFileName }}</strong>
    </p>

    <button mat-raised-button color="accent"
      [disabled]="downloadState === 'downloading'"
      (click)="download()">
      <mat-icon>cloud_download</mat-icon>
      {{ downloadState === 'downloading' ? 'Descargando...' : 'Descargar fichero' }}
    </button>

    <mat-progress-bar *ngIf="downloadState === 'downloading'" mode="indeterminate"></mat-progress-bar>
  </section>

  <p *ngIf="uploadState === 'error' || downloadState === 'error'" class="error-text">
    <mat-icon>error</mat-icon>
    {{ errorMessage }}
  </p>
</div>
